// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"94":"57e5b827","122":"b81dc0c9","618":"846dd1fe"}[chunkId] + ".css";
};